import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable.tsx";
import { db, userDataCollection } from "@/firebase";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class BalliGrit extends Vue {
  completed = false;
  private _questions: [{ question: string; answer: number; qid: number }];
  private introCompleted = false;

  constructor() {
    super();
    this._questions = this.$store.getters.balliQuestions.grit;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balliQuestions.grit;
  }

  hasCompleted(completed: boolean) {
    this.completed = completed;
  }

  submit() {
    var thisUser = this.$store.getters.user;
    var uid = thisUser.data.uid;

    if (this.$store.getters.balliSections[4].progress != 100) {
      let timepoint = this.$store.getters.balliTimepointStr;

      updateStudentScoring();

      // Store the responses
      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(this.$store.getters.balliTimepointStr)
        .collection("responses")
        .doc("grit")
        .set({ Answers: this._questions })
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("balli")
            .doc(timepoint)
            .update({
              "completionStatus.grit": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          //console.log("Error writing responses for Balli Grit: ", error);
        });

      // Update progress in $store
      this.$store.commit("markBalliComplete", "Grit");
      this.$store.commit("progressBalli", this._questions.length);
    }

    // Move to Outro
    this.$router.push({ name: "balliOutro" });
  }

  private introScreen() {
    return (
      <Card>
        <div slot="mainContent">
          <span class="subtitle-1">Let’s talk about your grit!</span>
        </div>
        <div slot="actions">
          <v-btn
            color="primary"
            onClick={() => {
              this.introCompleted = true;
            }}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  private mainContent() {
    return (
      <Card
        title="Think about how you complete reading and writing tasks. Does this sound like you?"
        mod={Module.BALLI}
      >
        <v-form ref="form" slot="mainContent">
          <RadioTable
            questions={this._questions}
            onUpdate={this.hasCompleted}
            fixHeader={true}
            disabled={this.$store.getters.balliSections[4].progress == 100}
            labelType={this.$store.getters.balliRadioHeader}
          ></RadioTable>
        </v-form>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="regulation">
            Back
          </v-btn>
          <v-btn
            color="primary"
            disabled={!this.completed}
            onClick={this.submit}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.introCompleted ? this.mainContent() : this.introScreen();
  }
}

const component = BalliGrit;
